__webpack_require__.p = "/admiro/";